import * as z from 'zod/mini'

/** Field rules specific to a premise's customer record (personal details are in `personFields`). */
export const customerFields = {
  /** A manual adjustment: may go negative, bounded so a typo cannot wreck the balance. */
  loyaltyPoints: z.int().check(z.minimum(-99999), z.maximum(99999)),
  /** The code on the customer's physical card. Trimmed; never empty. */
  cardId: z.string().check(z.trim(), z.minLength(1), z.maxLength(255)),
}
